<template>
    <!-- Breadcrumb -->
    <div class="breadcrumb-bar" style="background-color: #3CB371;">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-md-12 col-12">
                    <nav aria-label="breadcrumb" class="page-breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><router-link to="/">Home</router-link></li>
                            <li class="breadcrumb-item active" aria-current="page">Appointments</li>
                        </ol>
                    </nav>
                    <h2 class="breadcrumb-title">Patient Appointments as on {{ currentDay }}, {{ todays_date }}</h2>
                </div>
            </div>
        </div>
    </div>
    <!-- /Breadcrumb -->
</template>


<script>
export default {
  data() {
    return {
      todays_date: new Date()
        .toString()
        .split(" ")
        .splice(1, 3)
        .join(" ")
    };
  },

  computed: {
    currentDay() {
      const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      const today = new Date().getDay(); // Get the current day of the week (0-6)
      return daysOfWeek[today];
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/breadcrumb/Appointments.vue